




















import { Component, Vue, Prop } from "vue-property-decorator";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";

@Component
export default class ButtonInspect extends Vue {
  @Prop() type: string;
  @Prop() all: boolean;
  @Prop({ default: 0 })
  status: number;
  @Prop({ default: "" })
  textBtn: string;
  @Prop({ default: false })
  isOsusume: boolean;

  isActive: boolean = false;
  isCircle: boolean = false;
  isTriangle: boolean = false;
  isCross: boolean = false;

  created() {
    this.isCircle = this.type === "circle";
    this.isTriangle = this.type === "triangle";
    this.isCross = this.type === "cross";
  }

  setValue() {
    this.isActive = true;
    if (!this.isOsusume) {
    const value = this.isCircle
      ? InspectButtonValue.CIRCLE
      : this.isTriangle
        ? InspectButtonValue.TRIANGLE
        : InspectButtonValue.CROSS;
    this.$emit("onclick", { isActive: this.isActive, value });
    } else {
      if (this.textBtn == '提案する') {
        this.$emit("onclick", { isActive: this.isActive, osusumeIsShow: 1 });
      } else if (this.textBtn == 'しない') {
        this.$emit("onclick", { isActive: this.isActive, osusumeIsShow: 0 });
      }
    }
  }

  onClick() {
    if (
      !this.textBtn &&
      (this.status == STATUS_SELECT_WORK_BUHIN.Done &&
      this.isCircle &&
      !this.isActive)
    ) {
      this.$emit("onconfirm");
    } else if (!this.isActive) {
      this.setValue();
    }
  }
}
